import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-fela'
import ds from 'views/styles/designSystem'
import { pxTo } from 'design-system-utils'
import { NavLink } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import Container from 'views/components/presentationals/atoms/Container'
import Icon from 'views/components/presentationals/Icon'

const legalNotice = require('assets/pdf/LEGAL_NOTICE_GLINKO.pdf')

const Footer = ({ styles }) => (
  <footer className={styles.footer}>
    <Container className={styles.container}>
      <Icon name="logo-glinko-white" />
      <div className={styles.part}>
        <FormattedMessage id="layouts.footer.company.title">
          {(txt) => <h4 className={styles.subtitle}>{txt}</h4>}
        </FormattedMessage>
        <ul className={styles.list}>
          {/* <li className={styles.item}>
            <FormattedMessage id="layouts.footer.company.who">
              {(txt) => (
                <a href="/" className={styles.link}>
                  {txt}
                </a>
              )}
            </FormattedMessage>
          </li> */}
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.company.contact">
              {(txt) => (
                <NavLink to="/contact" className={styles.link}>
                  {txt}
                </NavLink>
              )}
            </FormattedMessage>
          </li>
        </ul>
      </div>
      <div className={styles.part}>
        <FormattedMessage id="layouts.footer.resources.title">
          {(txt) => <h4 className={styles.subtitle}>{txt}</h4>}
        </FormattedMessage>
        <ul className={styles.list}>
          {/* <li className={styles.item}>
            <FormattedMessage id="layouts.footer.resources.faq">
              {(txt) => (
                <a href="/" className={styles.link}>
                  {txt}
                </a>
              )}
            </FormattedMessage>
          </li> */}
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.resources.legalNotice">
              {(txt) => (
                <a href={legalNotice} target="_blank" rel="noopener noreferrer" className={styles.link}>
                  {txt}
                </a>
              )}
            </FormattedMessage>
          </li>
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.resources.tos">
              {(txt) => (
                <NavLink to="/tos" className={styles.link}>
                  {txt}
                </NavLink>
              )}
            </FormattedMessage>
          </li>
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.resources.privacyPolicy">
              {(txt) => (
                <NavLink to="/privacy-policy" className={styles.link}>
                  {txt}
                </NavLink>
              )}
            </FormattedMessage>
          </li>
        </ul>
      </div>
      <div className={styles.part}>
        {/* <FormattedMessage id="layouts.footer.about.title">
          {(txt) => <h4 className={styles.subtitle}>{txt}</h4>}
        </FormattedMessage>
        <ul className={styles.list}>
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.about.twitter">
              {(txt) => (
                <a href="/" className={styles.link}>
                  {txt}
                </a>
              )}
            </FormattedMessage>
            <Icon name="twitter" className={styles.icon} />
          </li>
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.about.linkedin">
              {(txt) => (
                <a href="/" className={styles.link}>
                  {txt}
                </a>
              )}
            </FormattedMessage>
            <Icon name="linkedin" className={styles.icon} />
          </li>
          <li className={styles.item}>
            <FormattedMessage id="layouts.footer.about.blog">
              {(txt) => (
                <a href="/" className={styles.link}>
                  {txt}
                </a>
              )}
            </FormattedMessage>
          </li>
        </ul> */}
      </div>
    </Container>
  </footer>
)

Footer.propTypes = {
  styles: PropTypes.object.isRequired,
}

const rules = {
  footer: () => ({
    backgroundColor: ds.brand('blueNight'),
    color: ds.brand('greyLighter'),
    padding: `${pxTo(50, ds.get('type.baseFontSize'), 'rem')} 0`,
    marginTop: 'auto',
  }),
  container: () => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'start',
    margin: '0 auto',
    maxWidth: '100%',
    padding: `0 ${pxTo(ds.get('layout.gutter') / 2, ds.get('type.baseFontSize'), 'rem')}`,
    '@media (min-width: 768px)': {
      flexDirection: 'row',
    },
  }),
  part: () => ({
    margin: `${pxTo(20, ds.get('type.baseFontSize'), 'rem')} 0`,
    ':first-of-type': {
      marginTop: pxTo(40, ds.get('type.baseFontSize'), 'rem'),
    },
    ':last-child': {
      marginBottom: 0,
    },
    '@media (min-width: 768px)': {
      margin: 0,
      ':first-of-type': {
        marginTop: 0,
      },
      ':last-child': {
        marginBottom: 0,
      },
    },
  }),
  subtitle: () => ({
    fontSize: pxTo(ds.get('type.sizes.headings.level4'), ds.get('type.baseFontSize'), 'rem'),
    lineHeight: pxTo(ds.get('type.sizes.headings.level4') * 1.1875, ds.get('type.baseFontSize')),
    margin: `0 0 ${pxTo(10, ds.get('type.baseFontSize'), 'rem')}`,
  }),
  list: () => ({
    listStyle: 'none',
    padding: 0,
    margin: 0,
    lineHeight: pxTo(20, ds.get('type.baseFontSize')),
  }),
  item: () => ({
    display: 'flex',
    alignItems: 'center',
  }),
  icon: () => ({
    display: 'flex',
    height: pxTo(14, ds.get('type.baseFontSize'), 'rem'),
    margin: `0 0 0 ${pxTo(10, ds.get('type.baseFontSize'), 'rem')}`,
  }),
  link: () => ({
    color: ds.get('colors.white'),
    textDecoration: 'none',
  }),
}

export default connect(rules)(Footer)
